module.exports = __webpack_public_path__ + "static/media/hand-top.4c4fc2b4.png";